import { useFetchHtmlFromUrl } from "screens/designStudio/hooks/useFetchHtmlFromUrl";
import styles from "./HTMLPreview.module.scss";
import { useTemplateRenderContext } from "screens/designStudio/hooks/TemplateRenderDataProvider";
import { LoadingOutlined } from "@ant-design/icons";
const HTMLPreview = () => {
  const { setHtmlIframeRef, file } = useTemplateRenderContext();
  const { data: selectedFile, isLoading } = useFetchHtmlFromUrl(file);

  return (
    <div className={styles.container}>
      {isLoading && (
        <div className={styles.loading}>
          <div className={styles.overlay}>
            <LoadingOutlined className={styles.icon} />
            <div className={styles.title}>Loading preview...</div>
          </div>
        </div>
      )}
      {!isLoading && (
        <iframe
          className={styles.iframe}
          ref={ref => {
            setTimeout(() => {
              setHtmlIframeRef(ref);
            }, 1000);
          }}
          srcDoc={selectedFile?.html}
        ></iframe>
      )}
    </div>
  );
};
export default HTMLPreview;
